var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.5 2h-12.5c-1.10457 0-2 .89543-2 2v12c0 1.1046.89543 2 2 2h12c1.1046 0 2-.8954 2-2v-10.5l-1 1v9.5c0 .5523-.4477 1-1 1h-12c-.55228 0-1-.4477-1-1v-12c0-.55228.44772-1 1-1h11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 19v1c0 1.1046.89543 2 2 2h12c1.1046 0 2-.8954 2-2v-12c0-1.10457-.8954-2-2-2h-1v1h1c.5523 0 1 .44772 1 1v12c0 .5523-.4477 1-1 1h-12c-.55228 0-1-.4477-1-1v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 3.5c-.2064-.18346-.5224-.16487-.7059.04152l-7.33821 8.25548-3.25035-2.84404c-.20782-.18184-.5237-.16078-.70554.04704s-.16078.5237.04704.70554l3.99707 3.49746 7.99739-8.99711c.1835-.20639.1649-.52243-.0415-.70589z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.9a7325b6cbd976ebf7a8d52d8048a85f.svg";
export { ForwardRef as ReactComponent };